import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { forkJoin } from 'rxjs';
import { NotificationManager } from '../../../../../managers/notification.manager';
import { UserManager } from '../../../../../managers/user.manager';
import { UserResource } from '../../../../../models/resource/user.resource';
import { salutations } from '../../../../../models/salutations.model';
import { User } from '../../../../../models/ui/user.model';
import { UserProfile } from '../../../../../models/user-profile.model';
import { UserProfileService } from '../../../../../services/user-profile.service';

@Component({
    selector: 'lex-user-edit-dialog',
    templateUrl: './user-edit-dialog.component.html',
    styleUrls: ['./user-edit-dialog.component.scss'],
    standalone: false
})
export class UserEditDialogComponent {

	public editUserProfileForm: UntypedFormGroup;
	private user: User;
	private userProfile: UserProfile;

	public salutations = salutations;

	constructor(
		private formBuilder: UntypedFormBuilder,
		private dialogRef: MatDialogRef<UserEditDialogComponent>,
		private userProfileService: UserProfileService,
		private userManager: UserManager,
		private notificationManager: NotificationManager,
		@Inject(MAT_DIALOG_DATA) private data: any) {
		this.user = data.selectedUser;
		this.userProfile = data.selectedUserProfile;
		this.editUserProfileForm = this.formBuilder.group({
			userName: [this.user.userName, [Validators.required, Validators.maxLength(256)]],
			email: [this.user.email, [Validators.required, Validators.maxLength(256)]],
			salutation: [this.userProfile.salutation, [Validators.required, Validators.maxLength(16)]],
			firstName: [this.userProfile.firstName, [Validators.required, Validators.maxLength(256)]],
			lastName: [this.userProfile.lastName, [Validators.required, Validators.maxLength(256)]],
			organization: [this.userProfile.organization, [Validators.required, Validators.maxLength(256)]],
		});
	}

	public submit(): void {

		if (!this.editUserProfileForm.valid)
			return;

		this.userProfile.firstName = this.editUserProfileForm.controls['firstName'].value;
		this.userProfile.lastName = this.editUserProfileForm.controls['lastName'].value;
		this.userProfile.organization = this.editUserProfileForm.controls['organization'].value;
		this.userProfile.salutation = this.editUserProfileForm.controls['salutation'].value;

		const jobPatch = { userName: this.editUserProfileForm.controls['userName'].value, email: this.editUserProfileForm.controls['email'].value } as Partial<UserResource>

		forkJoin([
			this.userManager.updateUser(this.user.id, jobPatch),
			this.userProfileService.updateUserProfile(this.userProfile)
		]).subscribe({
			next: () => this.dialogRef.close(true),
			error: () => {
				this.notificationManager.displaySnackBarMessage({
					message: 'An error has occurred.',
					type: 'error'
				})}});
	}
}
